export default __webpack_public_path__ + "static/media/wing-left.4c91db55.png";